import TrackingContext from './TrackingContext';
import { useContext } from 'react';

export default function useTracking() {
  const tracking = useContext(TrackingContext);
  return tracking;
}
